module.exports = __webpack_public_path__ + "img/avatar-woman.fdea62df.svg";